import React from "react";
import fourOfour from "./404page.png";

const Fourofour = () => {
  return <img src={fourOfour} />;
};

export default Fourofour;
